import React, { useState } from "react";

export default function LoanEligibilityCalculator() {
    const [income, setIncome] = useState("");
    const [existingEMI, setExistingEMI] = useState("");
    const [tenure, setTenure] = useState("");
    
  const [eligibleAmount, setEligibleAmount] = useState(null);

  const calculateEligibility = () => {
    const maxEmi = income * 0.5 - existingEMI;
    if (maxEmi <= 0) {
      setEligibleAmount(0);
      return;
    }
    const monthlyRate = 0.013;
    const amount =
      maxEmi * ((1 - Math.pow(1 + monthlyRate, -tenure)) / monthlyRate);
    setEligibleAmount(amount.toFixed(2));
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #E9F0FF, #F7F9FC)",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "white",
          width: "100%",
          maxWidth: "550px",
          borderRadius: "22px",
          boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
          padding: "30px",
          transition: "0.3s",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            background: "linear-gradient(135deg, #4A90E2, #50E3C2)",
            padding: "15px",
            borderRadius: "15px",
            textAlign: "center",
            color: "white",
            marginBottom: "25px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.10)",
          }}
        >
          <h2 style={{ margin: 0, fontWeight: "700" }}>
            Loan Eligibility Calculator
          </h2>
          <p style={{ margin: 0, fontSize: "0.9rem" }}>
            Check your maximum loan amount instantly
          </p>
        </div>

        {/* INPUTS */}
        <div style={{ marginBottom: "20px" }}>
          <label className="fw-semibold">Monthly Income (₹)</label>
          <input
            type="number"
            className="form-control mt-1"
            style={{
              borderRadius: "12px",
              padding: "10px",
              border: "1px solid #D0D7E6",
            }}
            value={income}
            onChange={(e) => setIncome(Number(e.target.value))}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label className="fw-semibold">Existing Monthly EMI (₹)</label>
          <input
            type="number"
            className="form-control mt-1"
            style={{
              borderRadius: "12px",
              padding: "10px",
              border: "1px solid #D0D7E6",
            }}
            value={existingEMI}
            onChange={(e) => setExistingEMI(Number(e.target.value))}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label className="fw-semibold">Loan Tenure (Months)</label>
          <input
            type="number"
            className="form-control mt-1"
            style={{
              borderRadius: "12px",
              padding: "10px",
              border: "1px solid #D0D7E6",
            }}
            value={tenure}
            onChange={(e) => setTenure(Number(e.target.value))}
          />
        </div>

        {/* BUTTON */}
        <button
          onClick={calculateEligibility}
          style={{
            width: "100%",
            background: "linear-gradient(135deg, #4A90E2, #50E3C2)",
            border: "none",
            padding: "12px",
            borderRadius: "14px",
            color: "white",
            fontSize: "1.1rem",
            fontWeight: "600",
            boxShadow: "0 8px 18px rgba(0,0,0,0.15)",
            transition: "0.3s",
          }}
          onMouseOver={(e) => (e.target.style.transform = "scale(1.03)")}
          onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
        >
          Calculate Eligibility
        </button>

        {/* RESULT BOX */}
        {eligibleAmount !== null && (
          <div
            style={{
              marginTop: "25px",
              background: "#E7FFF3",
              border: "1px solid #98E2C6",
              padding: "20px",
              borderRadius: "16px",
              textAlign: "center",
              boxShadow: "0 5px 15px rgba(0,0,0,0.08)",
            }}
          >
            <p style={{ fontSize: "1.1rem", fontWeight: "600" }}>
              Eligible Loan Amount
            </p>
            <p
              style={{
                fontSize: "2rem",
                fontWeight: "700",
                color: "#0A9A62",
              }}
            >
              ₹ {eligibleAmount}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
